import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import _ from 'lodash';
import { joinValuesToString } from 'ziphy-web-shared/basic/helpers';
import { Input } from 'ziphy-web-shared/basic/lib/forms/fields';
import { getInputProps } from './';
import DateTime from './dateTime/DateTime';
import styles from './InputDefault.module.scss';
const InputDefault = ({ $element }) => {
    const { fieldProps, units, masks } = useMemo(() => getInputProps($element), [$element.config]);
    const { renderType, config, field } = $element;
    if (Array.isArray(config.usedKeys)) {
        const getUnits = (key) => {
            const separator = _.isObject(config.separator) ? config.separator[key] : undefined;
            const unit = _.isObject(units) ? units[key] || '' : units;
            return [unit ? ' ' + unit : '', separator];
        };
        if (renderType === 'plain') {
            return field.value ? (_jsxs("span", { children: [config.usedKeys.map((key) => {
                        var _a;
                        return ((_a = field.value) === null || _a === void 0 ? void 0 : _a[key])
                            ? joinValuesToString([field.value[key], ...getUnits(key)], '')
                            : '';
                    }), field.value.datetime ? _jsx(DateTime, { datetime: field.value.datetime }) : null] })) : null;
        }
        return (_jsx("div", Object.assign({ className: styles.wrapper }, { children: config.usedKeys.map((key) => (_jsxs(Fragment, { children: [_jsx(Input, Object.assign({}, fieldProps, { field: Object.assign(Object.assign({}, field), { value: field.value[key], onChange: (value) => field.onChange(Object.assign(Object.assign({}, field.value), { [key]: value })) }), mask: (masks === null || masks === void 0 ? void 0 : masks[key]) || masks })), getUnits(key).map((unit) => unit)] }, key))) })));
    }
    const unit = _.isObject(units) ? Object.values(units)[0] : units;
    if (renderType === 'plain') {
        return field.value ? _jsx("span", { children: joinValuesToString([field.value, unit], ' ') }) : null;
    }
    return (_jsxs("div", Object.assign({ className: styles.wrapper }, { children: [_jsx(Input, Object.assign({ field: field }, fieldProps, { mask: masks })), unit] })));
};
export default observer(InputDefault);
